import { apiClient } from '@app/api';
import { queryClient } from '@app/core/integrations/react-query/react-query';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { AudiogramProps } from '@mi-front/audiogram';
import { Title } from '@ui/components';
import { omit } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { getFragmentMediaUrl } from '../../../../../utils/fragment-media-url';
import { AudiogramGenerator } from './AudiogramGenerator';
import { useFragment } from '../../../hooks/useFragment';

export function AudiogramPreview() {
  const { fragment, station } = useFragment();

  const audioFileUrl = getFragmentMediaUrl(fragment);

  if (!audioFileUrl) {
    return null;
  }

  const captionsUrl = apiClient.generateUrl(`/fragments/${fragment.id}/audiogram/captions`, {
    secure: true,
  });

  const playerProps: Partial<AudiogramProps> = {
    audioFileUrl,
    captionsUrl,
    coverImageUrl: station.logoUrl!,
    titleText: fragment.title,
    variant: '1x1',
  };

  return (
    <div className="">
      <Title className="mb-3 font-size-base">
        <FormattedMessage id="audiogram.generateAudiogram" defaultMessage="Generar audiogram" />
      </Title>
      <AudiogramGenerator
        playerProps={playerProps}
        onSuccess={(values) => {
          return apiClient.fragments
            .audiogramGenerate(fragment.id, {
              variants: values.data.variants,
              inputProps: {
                ...omit(values.data, 'variants'),
                captionsUrl,
              },
            })
            .then(() => {
              queryClient.invalidateQueries({
                queryKey: useFragmentQuery.queryKey(fragment.id),
              });
            });
        }}
      />
    </div>
  );
}
